import React, { memo } from 'react';

import ModelPageRenderer from '@/components/atomic/atoms/utils/model-page-renderer';
import manipulator from '@/utils/entry/manipulator';
import type { EntryProps } from '@/utils/entry/typings';

const MainRendererComponent: React.FC<
	Pick<EntryProps, 'fragmentVariationPath'>
> = ({ fragmentVariationPath }) => (
	<ModelPageRenderer
		fragmentVariationPath={fragmentVariationPath}
		manipulator={manipulator}
	/>
);

const MainRenderer = memo(MainRendererComponent);

export default MainRenderer;
